const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'site.fqdn', label: 'FQDN', sortable: false },
    { key: 'site.name', label: 'Name', sortable: false },
    { key: 'last_time', label: 'Last Time', sortable: true },
    { key: 'due_time', label: 'Next Time', sortable: true },
    { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 25%'  },
  ],
  KO: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'site.fqdn', label: 'FQDN', sortable: false },
    { key: 'site.name', label: '이름', sortable: false },
    { key: 'last_time', label: '최근 점검 시간', sortable: true },
    { key: 'due_time', label: '다음 점검 예정', sortable: true },
    { key: 'func', label: '기능', sortable: false, thStyle: 'width: 25%'  },
  ],
  JP : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'site.fqdn', label: 'FQDN', sortable: false },
    { key: 'site.name', label: '名前', sortable: false },
    { key: 'last_time', label: '前回', sortable: true },
    { key: 'due_time', label: '次回', sortable: true },
    { key: 'func', label: 'アクション', sortable: false, thStyle: 'width: 25%'  }
  ]
}

const _i18n_info = {
  remove_schedule : {
    EN: `Schedule Remove Completion`,
    KO: `Schedule Remove Completion`,
    JP: `削除完了のスケジュール設定`
  }
}

const _i18n_success = {
  done : {
    EN: `request`,
    KO: `request`,
    JP: `要求`
  }
}

const _i18n_warning = {
  failed_custom : {
    EN: `custom `,
    KO: `custom `,
    JP: `カスタム `
  }
}

const _i18n_error = {
  load_failed : {
    EN: `can't not load schedule`,
    KO: `can't not load schedule`,
    JP: `スケジュールを読み込めません`
  }
}

const _i18n_data = {
  i18n_fields,
  _i18n_info,
  _i18n_success,
  _i18n_warning,
  _i18n_error
}

export default _i18n_data